import type {PropsWithChildren} from 'react';
import {jsCompanyInformationId} from '../lib/const';
import styles from './root.module.css';

type Props = PropsWithChildren;

export function BreadCrumbRoot({children}: Props) {
  return (
    <div id={jsCompanyInformationId}>
      <nav className={styles.root}>{children}</nav>
    </div>
  );
}
